var _defs, _g, _polygon, _polygon2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path, _path2, _polygon3, _polygon4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatFlat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#407bff;}.cls-2{fill:#24285b;}.cls-3{fill:#0099f5;}.cls-4{opacity:0.2;isolation:isolate;}.cls-5{fill:#ededeb;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Contact Us") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-1215"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "393.95 182.88 473.27 131.2 402.56 161.79 393.95 182.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "393.95 182.88 473.27 131.2 402.56 161.79 393.95 182.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "370.72 145.59 387.1 154.82 393.95 182.88 402.56 161.79 430.16 172.68 473.27 131.2 370.72 145.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "370.72 145.59 387.1 154.82 393.95 182.88 402.56 161.79 430.16 172.68 473.27 131.2 370.72 145.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "387.1 154.82 473.27 131.2 402.56 161.79 393.95 182.88 387.1 154.82"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "92.7 238.88 250.39 106.38 408.06 238.88 284.43 404.71 173.39 402.48 92.7 238.88"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "92.7 238.88 250.39 106.38 408.06 238.88 284.43 404.71 173.39 402.48 92.7 238.88"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 138.23,
    y: 62.71,
    width: 224.3,
    height: 327.94,
    rx: 5.17
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 162.11,
    y: 102.31,
    width: 176.56,
    height: 6.67,
    rx: 1.65
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 162.11,
    y: 124.53,
    width: 176.56,
    height: 6.67,
    rx: 1.65
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 162.11,
    y: 146.76,
    width: 176.56,
    height: 6.67,
    rx: 1.65
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 162.11,
    y: 168.99,
    width: 176.56,
    height: 6.67,
    rx: 1.65
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 162.11,
    y: 191.21,
    width: 176.56,
    height: 6.67,
    rx: 1.65
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 162.11,
    y: 213.44,
    width: 176.56,
    height: 6.67,
    rx: 1.65
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 162.11,
    y: 235.66,
    width: 176.56,
    height: 6.67,
    rx: 1.65
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 162.11,
    y: 257.86,
    width: 176.56,
    height: 6.67,
    rx: 1.65
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 162.11,
    y: 280.09,
    width: 176.56,
    height: 6.67,
    rx: 1.65
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M258.83,354.44,258,354a10.47,10.47,0,0,0-10.23,0l-4.25,2.41L91.94,238.88V432.82A10.18,10.18,0,0,0,102.16,443H398.45c5.7,0,8.37-4.39,8.37-10.13V238.88Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M258.83,354.44,258,354a10.47,10.47,0,0,0-10.23,0l-4.25,2.41L91.94,238.88V432.82A10.18,10.18,0,0,0,102.16,443H398.45c5.7,0,8.37-4.39,8.37-10.13V238.88Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "236.62 351.11 243.47 356.42 136.39 417.21 236.62 351.11"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "375.79 419.51 258.67 354.56 264.07 350.33 375.79 419.51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatFlat);
export default __webpack_public_path__ + "static/media/chat-flat.0121d17dd9a09eb766be4af856abb936.svg";
export { ForwardRef as ReactComponent };